import type { StoredReaderPdfBookmark, StoredReaderPdfNote } from "@/interface/DTO_Interfaces"
import api from "./client"

export interface ReaderAnnotationScope { bookId: string; pdfId: string }
export interface ReaderAnnotations { bookmarks: StoredReaderPdfBookmark[]; notes: StoredReaderPdfNote[] }

export const readerAnnotationsApi = (scope: ReaderAnnotationScope) => {
        const root = `reader/${encodeURIComponent(scope.bookId)}/${encodeURIComponent(scope.pdfId)}`
        return {
                read: async () => (await api.get<ReaderAnnotations>(root)).data,
                addBookmark: async (bookmark: Omit<StoredReaderPdfBookmark, "id">) =>
                        (await api.post<StoredReaderPdfBookmark>(`${root}/bookmarks`, bookmark)).data,
                removeBookmarks: async (pageNumbers: number[]) => { await api.delete(`${root}/bookmarks`, { data: { pageNumbers } }) },
                addNote: async (note: Omit<StoredReaderPdfNote, "id">) =>
                        (await api.post<StoredReaderPdfNote>(`${root}/notes`, note)).data,
                updateNote: async (noteId: string, changes: { text: string; color: string }) =>
                        (await api.patch<StoredReaderPdfNote>(`${root}/notes/${encodeURIComponent(noteId)}`, changes)).data,
                removeNotes: async (noteIds: string[]) => { await api.delete(`${root}/notes`, { data: { noteIds } }) },
        }
}
